module.exports = __webpack_public_path__ + "static/media/mode8.86bf839e.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/system/mode8.gif
// module id = 1353
// module chunks = 110